goog.provide("shadow.js.shim.module$$mui$material$Autocomplete$default");
shadow.js.shim.module$$mui$material$Autocomplete$default = shadow.js.shim.module$$mui$material$Autocomplete.default;
